<div class="company-documents-form">
  <div class="card company-document-inner-card">
    <div class="card-body">
      <h5 class="company-document-section-title">Document</h5>

      <form [formGroup]="form">
        <div class="row">

          <div class="col-lg-2 col-md-4 col-sm-6">
            <input-field
              label="Code"
              [inputFormControl]="getControl('code')"
              [placeholder]="' '"
              [type]="'text'"
              [readonly]="true">
            </input-field>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="fw-bold company-document-field-label">Dept.</label>
            <select-field
              [selectFormControl]="getControl('department')"
              [options]="departmentOptions"
              (selectionChange)="onDepartmentChange($event)">
            </select-field>
          </div>

          <div class="col-lg-4 col-md-8 col-sm-12">
            <input-field
              label="Doc. Name"
              placeholder="Name of the procedure or policy"
              [inputFormControl]="getControl('name')"
              [type]="'text'">
            </input-field>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="fw-bold company-document-field-label">Group</label>
            <select-field
              [selectFormControl]="getControl('companyDocumentGroupId')"
              [options]="groupOptions">
            </select-field>
          </div>

        </div>
      </form>
    </div>
  </div>

  @if (isEditPage) {
    <form [formGroup]="form">
      <div class="row mt-3">
        <div class="col-lg-3 col-md-6">
          <input-field
            label="Creator"
            [inputFormControl]="getControl('creator')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>
        <div class="col-lg-3 col-md-6">
          <input-field
            label="Current revision"
            [inputFormControl]="getControl('currentRevision')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>
        <div class="col-lg-6 col-md-12">
          <ng-content select="[companyDocumentExtraInfo]"></ng-content>
        </div>
      </div>
    </form>
  }

  @if (canSave) {
    <div class="d-flex justify-content-center align-items-center my-2">
      <button type="button" class="btn btn-primary" (click)="submitForm()">Save</button>
    </div>
  }
</div>
